import React, { useContext } from "react";
import { Button, Space, Avatar } from "antd";
import {
  UserOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined
} from "@ant-design/icons";
import { AppContext } from "../context/AppContext";

const HeaderContent = () => {
  const { collapsed, toggleSidebar, userSession } = useContext(AppContext);

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        width: "100%",
        alignItems: "center"
      }}
    >
      <Button
        type="text"
        icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
        onClick={toggleSidebar}
        style={{ fontSize: "16px", width: 64, height: 64, color: "#255B37" }}
      />
      <Space size="large">
        <Avatar
          icon={<UserOutlined />}
          style={{ cursor: "pointer", background: "#255B37" }}
        />
        <span
          style={{
            fontWeight: 500,
            display: "inline-block",
            lineHeight: "1"
          }}
        >
          {userSession.name} {userSession.lastname}
        </span>
      </Space>
    </div>
  );
};

export default HeaderContent;
